var _rect, _rect2, _rect3, _rect4, _circle, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 159,
    height: 144,
    viewBox: "0 0 159 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 14.8652,
    width: 51.5427,
    height: 51.5427,
    rx: 10,
    fill: "#9E96FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 128.816,
    y: 32.8701,
    width: 29.3594,
    height: 29.3594,
    rx: 10,
    fill: "#9E96FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 0.816406,
    y: 74.8701,
    width: 31.5329,
    height: 31.5329,
    rx: 8,
    fill: "#DEDBFF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 115.104,
    y: 106.821,
    width: 36.5935,
    height: 36.5935,
    rx: 8,
    fill: "#DEDBFF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84.293,
    cy: 78.3755,
    r: 60,
    fill: "#008D41"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.5762 81.6202L74.5567 94.6007L107.008 62.1494",
    fill: "#008D41"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5762 81.6202L74.5567 94.6007L107.008 62.1494",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.9b3affee2aad2234ea28aae3a4a9b221.svg";
export { ForwardRef as ReactComponent };